import { SubscriptionPlans } from "../enum";

export const checkIsFreePlan = (plan: SubscriptionPlans): boolean =>
  plan === SubscriptionPlans.FREE;
